import React from "react";
import PropTypes from "prop-types";
import CardImage from "./../CardImage";
import TextLayoutList285CategoryRow from "../TextLayoutList285CategoryRow";
import TextLayoutArticle285CategoryDate from "./../TextLayoutArticle285CategoryDate";
import TextLayoutArticle630CategoryDateSummary from "./../TextLayoutArticle630CategoryDateSummary";
import TextLayoutArticle334CategoryDateRow from "./../TextLayoutArticle334CategoryDateRow";
import TextLayoutArticle745CategoryDateOverlay from "./../TextLayoutArticle745CategoryDateOverlay";
import TextLayoutArticle400CategoryDate from "./../TextLayoutArticle400CategoryDate";
import TextLayoutList268Row from "./../TextLayoutList268Row";
import TextLayoutList400Category from "./../TextLayoutList400Category";
import TextLayoutArticle285Date from "./../TextLayoutArticle285Date";
import TextLayoutArticle285CategoryDateRow from "./../TextLayoutArticle285CategoryDateRow";
import TextLayoutArticle307DateRow from "./../TextLayoutArticle307DateRow";
import TextLayoutList218Row from "./../TextLayoutList218Row";
import TextLayoutArticle400DateSummary from "./../TextLayoutArticle400DateSummary";
import TextLayoutArticle400CategoryDate_Carousel from "./../TextLayoutArticle400CategoryDate_Carousel";
import TextLayoutList400CategoryCentered from "./../TextLayoutList400CategoryCentered";
import TextLayoutList630CategoryCentered from "./../TextLayoutList630CategoryCentered";
import TextLayoutList168Row from "./../TextLayoutList168Row";
import TextLayoutList285 from "./../TextLayoutList285";
import TextLayoutList400Row from "./../TextLayoutList400Row";
import TextLayoutArticle630DateSummary from "./../TextLayoutArticle630DateSummary";
import TextLayoutPerson285Profession from "./../TextLayoutPerson285Profession";
import { getCardImage } from "./getCardImage";
import { getCategoryLabel } from "./getCategoryLabel";
import routeNames from "./../../utilities/server/routeNames";

import {
  StyledCardContainerDesktop,
  StyledCardContainerTablet,
  StyledCardContainerMobile,
  StyledCardContainerLeftDesktop,
  StyledCardContainerLeftTablet,
  StyledCardContainerLeftMobile,
  StyledCardImageDesktop,
  StyledCardImageTablet,
  StyledCardImageMobile,
  StyledCardTextDesktop,
  StyledCardTextTablet,
  StyledCardTextMobile,
  StyledCardContainerOverlayMobile,
  StyledCardContainerOverlayTablet,
  StyledCardContainerOverlayDesktop,
} from "./styles";

export const checkTextComponentNames = (componentName, props) => {
  let components = {
    TextLayoutList285CategoryRow: TextLayoutList285CategoryRow,
    TextLayoutArticle285CategoryDate: TextLayoutArticle285CategoryDate,
    TextLayoutArticle630CategoryDateSummary: TextLayoutArticle630CategoryDateSummary,
    TextLayoutArticle334CategoryDateRow: TextLayoutArticle334CategoryDateRow,
    TextLayoutArticle745CategoryDateOverlay: TextLayoutArticle745CategoryDateOverlay,
    TextLayoutArticle400CategoryDate: TextLayoutArticle400CategoryDate,
    TextLayoutList268Row: TextLayoutList268Row,
    TextLayoutList400Category: TextLayoutList400Category,
    TextLayoutArticle285Date: TextLayoutArticle285Date,
    TextLayoutArticle285CategoryDateRow: TextLayoutArticle285CategoryDateRow,
    TextLayoutArticle307DateRow: TextLayoutArticle307DateRow,
    TextLayoutList218Row: TextLayoutList218Row,
    TextLayoutArticle400DateSummary: TextLayoutArticle400DateSummary,
    TextLayoutArticle400CategoryDate_Carousel: TextLayoutArticle400CategoryDate_Carousel,
    TextLayoutList285: TextLayoutList285,
    TextLayoutList400CategoryCentered: TextLayoutList400CategoryCentered,
    TextLayoutList630CategoryCentered: TextLayoutList630CategoryCentered,
    TextLayoutList168Row: TextLayoutList168Row,
    TextLayoutList400Row: TextLayoutList400Row,
    TextLayoutArticle630DateSummary: TextLayoutArticle630DateSummary,
    TextLayoutPerson285Profession: TextLayoutPerson285Profession,
  };

  if (Object.keys(components).includes(componentName)) {
    let Component = components[componentName];
    return Component;
  }
  return TextLayoutColumn;
};

const Card = ({
  context = null,
  clientContext = null,
  data = null,
  index = null,
  padding = null,
  width = null,
  height = null,
  component = "GridLayout",
  imageLocation = "top",
  textLayout = "TextLayoutColumn",
  currentCategorySettings = null,
  dataPath = null,
  section = null,
  imageLoading = null,
}) => {
  // console.log("card currentCategorySettings", currentCategorySettings);

  let { isMobile, isTablet, isAmp, isIE } = clientContext;
  let { settings } = context.data;

  let categorySettingsArticle = settings.landingArticlesCategory.categories;
  let subcategorySettingsArticle =
    settings.landingArticlesCategory.subcategories;

  let categorySettingsList = settings.landingListsCategory.categories;
  let subcategorySettingsList = settings.landingListsCategory.subcategories;

  if (data !== undefined && data !== null && data.fields !== undefined) {
    let {
      title,
      slug,
      summary,
      publishedDate,
      heroImage,
      heroVideo,
      image,
      // category,
      authors,
      categories,
      subCategory,
    } = data.fields;

    let contentType = data.sys.contentType.sys.id;

    let cardImage = getCardImage({
      slug,
      heroImage,
      heroVideo,
      image,
      width,
      height,
      contentType,
      component,
      context,
      clientContext,
      // category,
      categories,
      subCategory,
    });

    // Default card settings.
    let eventCard = null;
    let eventCardTitle = null;
    let cardLabel = null;
    let linkPath = null;
    let categoryPath = null;
    let categoryLabel = null;
    let authorData = null;

    if (contentType === "article") {
      eventCard = "ArticleCard";
      eventCardTitle = "ArticleCard-Title";
      cardLabel = "Features";
      linkPath = routeNames.article.replace(":slug", slug);
      let landingSettings = settings.landingArticlesCategory;
      let labels = getCategoryLabel({
        landingSettings,
        context,
        subCategory,
        categories,
        categorySettings: categorySettingsArticle,
        subcategorySettings: subcategorySettingsArticle,
        currentCategorySettings,
        dataPath,
        section,
      });
      categoryPath = labels.categoryPath;
      categoryLabel = labels.categoryLabel;
    } else if (contentType === "list") {
      eventCard = "ListCard";
      eventCardTitle = "ListCard-Title";
      cardLabel = "List";
      linkPath = routeNames.list.replace(":slug", slug);
      let landingSettings = settings.landingListsCategory;
      // console.log("title", title, categories, subCategory);
      let labels = getCategoryLabel({
        landingSettings,
        context,
        subCategory,
        categories,
        categorySettings: categorySettingsList,
        subcategorySettings: subcategorySettingsList,
        currentCategorySettings,
        dataPath,
        section,
      });
      categoryPath = labels.categoryPath;
      categoryLabel = labels.categoryLabel;
    } else if (contentType === "author") {
      eventCard = "PersonCard";
      eventCardTitle = "PersonCard-Title";
      cardLabel = "Person";
      linkPath = null;
      let landingSettings = settings.landingArticlesCategory;
      categoryPath = null;
      categoryLabel = null;
      authorData = data.fields;
    }

    let authorName = null;
    let authorRole = null;
    let authorPath = null;
    let authorImage = null;
    if (
      authors !== undefined &&
      authors !== null &&
      authors[0] !== undefined &&
      authors[0].fields !== undefined
    ) {
      authorName = authors[0].fields.title;
      authorRole = authors[0].fields.subtitle;
      authorImage = authors[0].fields.image; // Used for CardAuthor layouts. For author cards, set cardImage to this image.
      // @TODO add author path if we add an author page.
    }

    let analytics = {
      category: cardLabel,
      value: 5,
      label: linkPath,
      action: "click",
      redirect: true,
    };

    let StyledCardContainer = StyledCardContainerMobile;
    let StyledCardContainerLeft = StyledCardContainerLeftMobile;
    let StyledCardImage = StyledCardImageMobile;
    let StyledCardText = StyledCardTextMobile;
    let StyledCardContainerOverlay = StyledCardContainerOverlayMobile;

    if (isTablet) {
      StyledCardContainer = StyledCardContainerTablet;
      StyledCardContainerLeft = StyledCardContainerLeftTablet;
      StyledCardImage = StyledCardImageTablet;
      StyledCardText = StyledCardTextTablet;
      StyledCardContainerOverlay = StyledCardContainerOverlayTablet;
    }

    if (!isMobile && !isTablet) {
      StyledCardContainer = StyledCardContainerDesktop;
      StyledCardContainerLeft = StyledCardContainerLeftDesktop;
      StyledCardImage = StyledCardImageDesktop;
      StyledCardText = StyledCardTextDesktop;
      StyledCardContainerOverlay = StyledCardContainerOverlayDesktop;
    }

    let TextLayoutComponent = checkTextComponentNames(textLayout);

    // console.log("TextLayoutComponent", textLayout);
    // Card positions.
    // NOTE: All padding, margins should be handled in text layout component.
    // Image should have no padding.
    if (imageLocation === "top") {
      return (
        <StyledCardContainer clientContext={clientContext} isIE={isIE}>
          <StyledCardImage isIE={isIE}>
            {cardImage !== undefined && cardImage.url && (
              <CardImage
                context={context}
                clientContext={clientContext}
                contentType={contentType}
                linkPath={linkPath}
                analyticsEvent={analytics}
                width={cardImage.width}
                height={cardImage.height}
                schema={contentType}
                imageUrl={cardImage.url}
                title={cardImage.title}
                showPlayIcon={cardImage.showPlayIcon}
                hasHeroVideo={heroVideo || false}
                defaultImageTitle={"Image"}
                imageSettings={`&fit=fill&f=faces&fm=webp&q=80`}
                imageLoading={imageLoading}
              />
            )}
          </StyledCardImage>
          <StyledCardText>
            <TextLayoutComponent
              index={index}
              context={context}
              clientContext={clientContext}
              id={`text-layout-${index}`}
              schema={contentType}
              title={title}
              linkPath={linkPath}
              categoryPath={categoryPath}
              category={categoryLabel}
              summary={summary}
              publishedDate={publishedDate}
              authorName={authorName}
              authorRole={authorRole}
              authorPath={authorPath}
              eventCard={eventCard}
              eventCardTitle={eventCardTitle}
              cardLabel={cardLabel}
              authorData={authorData}
            />
          </StyledCardText>
        </StyledCardContainer>
      );
    } else if (imageLocation === "left") {
      return (
        <StyledCardContainerLeft clientContext={clientContext}>
          <StyledCardImage>
            {cardImage !== undefined && cardImage.url && (
              <CardImage
                context={context}
                clientContext={clientContext}
                contentType={contentType}
                linkPath={linkPath}
                analyticsEvent={analytics}
                width={cardImage.width}
                height={cardImage.height}
                schema={contentType}
                imageUrl={cardImage.url}
                title={cardImage.title}
                showPlayIcon={cardImage.showPlayIcon}
                hasHeroVideo={heroVideo || false}
                defaultImageTitle={"Image"}
                imageSettings={`&fit=fill&f=faces&fm=webp&q=80`}
                imageLoading={imageLoading}
              />
            )}
          </StyledCardImage>
          <StyledCardText>
            <TextLayoutComponent
              index={index}
              context={context}
              clientContext={clientContext}
              id={`text-layout-${index}`}
              schema={contentType}
              title={title}
              linkPath={linkPath}
              categoryPath={categoryPath}
              category={categoryLabel}
              summary={summary}
              publishedDate={publishedDate}
              authorName={authorName}
              authorRole={authorRole}
              authorPath={authorPath}
              eventCard={eventCard}
              eventCardTitle={eventCardTitle}
              cardLabel={cardLabel}
              authorData={authorData}
            />
          </StyledCardText>
        </StyledCardContainerLeft>
      );
    } else if (imageLocation === "overlay") {
      return (
        <StyledCardContainerOverlay clientContext={clientContext}>
          <StyledCardImage>
            {cardImage !== undefined && cardImage.url && (
              <CardImage
                context={context}
                clientContext={clientContext}
                contentType={contentType}
                linkPath={linkPath}
                categoryPath={categoryPath}
                analyticsEvent={analytics}
                width={cardImage.width}
                height={cardImage.height}
                schema={contentType}
                imageUrl={cardImage.url}
                title={cardImage.title}
                showPlayIcon={cardImage.showPlayIcon}
                hasHeroVideo={heroVideo || false}
                defaultImageTitle={"Image"}
                imageSettings={`&fit=fill&f=faces&fm=webp&q=80`}
                imageLoading={imageLoading}
              />
            )}
          </StyledCardImage>
          <StyledCardText>
            <TextLayoutComponent
              index={index}
              context={context}
              clientContext={clientContext}
              id={`text-layout-${index}`}
              schema={contentType}
              title={title}
              linkPath={linkPath}
              categoryPath={categoryPath}
              category={categoryLabel}
              summary={summary}
              publishedDate={publishedDate}
              authorName={authorName}
              authorRole={authorRole}
              authorPath={authorPath}
              eventCard={eventCard}
              eventCardTitle={eventCardTitle}
              cardLabel={cardLabel}
              authorData={authorData}
            />
          </StyledCardText>
        </StyledCardContainerOverlay>
      );
    } else if (imageLocation === "none") {
      return (
        <StyledCardContainer clientContext={clientContext}>
          <StyledCardText>
            <TextLayoutComponent
              index={index}
              context={context}
              clientContext={clientContext}
              id={`text-layout-${index}`}
              schema={contentType}
              title={title}
              linkPath={linkPath}
              categoryPath={categoryPath}
              category={categoryLabel}
              summary={summary}
              publishedDate={publishedDate}
              authorName={authorName}
              authorRole={authorRole}
              authorPath={authorPath}
              eventCard={eventCard}
              eventCardTitle={eventCardTitle}
              cardLabel={cardLabel}
              authorData={authorData}
            />
          </StyledCardText>
        </StyledCardContainer>
      );
    }
  }
  return null;
};

export default Card;

Card.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object,
  /**
   Data object
  */
  data: PropTypes.object.isRequired,
  /**
    Optional padding for styles.
  */
  padding: PropTypes.string,
  /**
    Which content schema
    Options: article, list
  */
  schema: PropTypes.string,
  /**
    Which item this is.
  */
  index: PropTypes.number,
  /**
    Override dimensions of width for the card image.
  */
  width: PropTypes.number,
  /**
    Override dimensions of height for the card image.
  */
  height: PropTypes.number,
  /**

  */
  imageLocation: PropTypes.string,
  /**

  */
  textLayout: PropTypes.string,
  /**
    Which component this belongs to, used for getting the style settings.
  */
  component: PropTypes.string,
  /**
   Loading property for the image.
   */
  imageLoading: PropTypes.string,
};
